export default __webpack_public_path__ + "static/media/OPS-Tracker-logo-white.d950f719.png";